const MinusIcon = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 24 24"
            {...props}
        >
            <path d="M0 10h24v4h-24z" />
        </svg>
    )
}
export default MinusIcon
